document.addEventListener("DOMContentLoaded", function () {
      Fancybox.bind("[data-fancybox='gallery']", {});
  });
  /*
  $(document).ready(function(){
      $('.cart-recommendations-slider').slick({
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          autoplay: true,
          autoplaySpeed: 2000,
          arrows: true,
          dots: true
      });
  });
  */
window._autofillcallbackhandler = window._autofillcallbackhandler || function() {};
